<template>
  <div>
    <div class="col-12 mt-3">
      <section-title :title="title" :has-line="true" />
    </div>
    <validation-observer ref="validatorForm">
      <div class="row">
        <div class="col-12">
          <div class="container-fluid text-right">
            <p>{{ breach }}</p>
          </div>
        </div>
        <div v-if="!isServiceCenter" class="col-12 pb-3">
          <div class="col-3">
            <ValidationProvider
              ref="serviceTypeField"
              v-slot="{ errors }"
              mode="eager"
              rules="required"
            >
              <CustomDropDown
                id="ddlServiceType"
                v-model="serviceType"
                required
                :options="serviceTypeList"
                fieldkey="id"
                fieldname="name"
                label="Tipo de Servicio:"
                placeholder="Seleccione"
                custom-error-msg="seleccione el tipo de servicio"
                class="custom-dropdown"
                :error="errors[0]"
                :disabled="isReadOnly || disabledDiscipline"
              />
            </ValidationProvider>
          </div>
        </div>
        <div class="col-md-3 col-sm-12">
          <div class="ml-3 mode-panel">
            <ValidationProvider
              ref="disciplineField"
              v-slot="{ errors }"
              mode="eager"
              rules="required"
            >
              <CustomDropDown
                id="ddlDiscipline"
                v-model="options.discipline"
                required
                :options="disciplineList"
                fieldkey="id"
                fieldname="name"
                :label="disciplineTypeLabel"
                placeholder="Seleccione"
                :error="errors[0] || showErrorDiscipline"
                :custom-error-msg="errorDisciplineMessage"
                class="custom-dropdown"
                :disabled="isReadOnly || disabledDiscipline"
                @input="onDisiplineChange"
              />
            </ValidationProvider>
          </div>
        </div>
        <div class="col-md-3 col-sm-12">
          <div class="mode-panel">
            <ValidationProvider
              v-slot="{ errors }"
              mode="eager"
              rules="required"
            >
              <CustomDropDown
                id="ddlMunicipality"
                v-model="options.municipality"
                required
                :options="municipality"
                fieldkey="id"
                fieldname="name"
                label="Pueblo:"
                placeholder="Seleccione"
                :error="errors[0]"
                :custom-error-msg="
                  resources[municipality.length > 0 ? 'R90026' : 'R90024']
                "
                class="custom-dropdown ml-3"
                :disabled="isReadOnly"
                @input="$emit('change-municipality')"
              />
            </ValidationProvider>
          </div>
        </div>
        <div class="offset-2 col-md-2 col-sm-12">
          <div class="mode-panel text-right mt-4">
            <ActionButton
              id="btnGetAvailableDates"
              variant="success m-2"
              :disabled="isReadOnly"
              @click="getAvailableDates()"
            >
              Buscar Disponibilidad
            </ActionButton>
          </div>
        </div>
      </div>
    </validation-observer>
    <div v-if="weekDays.length > 0 && showCalendar">
      <div class="col-12 mt-5">
        <section-title
          title="Calendario de Espacios Disponible"
          :has-line="true"
        />
      </div>
      <div class="row mt-4 ml-1">
        <WeekCalendar
          :days="weekDays"
          @select-schedule="(data) => $emit('select-schedule', data)"
          @change-week="changeWeek"
          @onSelectedDate="changeWeek"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ActionButton from '@/components/common/ActionButton';
import SectionTitle from '@/components/common/page/SectionTitle.vue';
import { CustomDropDown } from '@/components/common';
import resourcesService from '@/services/resources.js';
import WeekCalendar from '@/components/common/WeekCalendar/WeekCalendar';
import alert from '@/mixin/alert.mixin';
import loading from '@/mixin/loading.mixin';
import appointmentServices from '@/services/api/appointment.api';

import moment from 'moment';
import { ValidationObserver } from 'vee-validate';
import serviceTypes from '@/utils/constants/service-types';
export default {
  name: 'Tab6',
  components: {
    SectionTitle,
    CustomDropDown,
    ActionButton,
    WeekCalendar,
    ValidationObserver,
  },
  mixins: [alert, loading],
  props: {
    student: {
      type: Object,
      required: true,
    },
    cancelAppointmentId: {
      type: Number,
      default: () => null,
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    showCalendar: {
      type: Boolean,
      default: () => false,
    },
    defaultDiscipline: {
      type: Number,
      default: () => null,
    },
    serviceTypeId: {
      type: Number,
      default: () => null,
    },
  },
  data() {
    return {
      options: {
        discipline: null,
        municipality: null,
      },
      serviceType: null,
      disciplineList: [],
      municipality: [],
      hasValue: null,
      resources: [],
      weekDays: [],
      breach: '',
      breachOver: null,
      registrationDate: null,
      disabledDiscipline: false,
      hasActiveCoordinatedDiscipline: false,
      showErrorDiscipline: false,
      activeAppointmentErrorMessage: '',
    };
  },
  computed: {
    ...mapGetters({
      studentPreRegistry: 'getStudentPreRegistry',
    }),
    params() {
      return this.$route.query;
    },
    errorDisciplineMessage() {
      let message = this.hasActiveCoordinatedDiscipline
        ? this.activeAppointmentErrorMessage
        : this.resources['R90025'];
      return message || '';
    },
    title() {
      let serviceTypeDesc;
      switch (this.serviceTypeId) {
        case serviceTypes.EvaluacionInicial:
          serviceTypeDesc = 'Coordinación de Cita para Evaluación Inicial';
          break;
        case serviceTypes.EvaluacionAdicional:
          serviceTypeDesc = 'Coordinación de Cita para Evaluación Adicional';
          break;
        case serviceTypes.CentroDeServicio:
          serviceTypeDesc = 'Coordinación de Citas para Centro de Servicio';
          break;
        default:
          serviceTypeDesc = 'Coordinación de Cita';
      }

      return serviceTypeDesc;
    },
    isServiceCenter() {
      return this.serviceTypeId == serviceTypes.CentroDeServicio;
    },
    disciplineTypeLabel() {
      return this.isServiceCenter ? 'Tipo de Servicio:' : 'Disciplina:';
    },
    serviceTypeList() {
      return [
        {
          id: serviceTypes.EvaluacionInicial,
          name: 'Evaluación Inicial',
        },
        {
          id: serviceTypes.EvaluacionAdicional,
          name: 'Evaluación Adicional',
        },
      ];
    },
  },
  methods: {
    async getRegistrationDate() {
      if (!this.registrationDate) {
        const { data } = await this.$ApiGet(
          `/api/appointment/getregistrationdate?studentSieId=${this.student.studentId}`
        );
        this.registrationDate = moment(data).format('YYYY/MM/DD');
      }

      return this.registrationDate;
    },
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages([
        'R90024',
        'R90025',
        'R90026',
        'R90027',
      ]);
    },
    async getAvailableDates(startDate) {
      startDate = startDate || '';

      if (
        this.options.discipline &&
        this.options.municipality &&
        this.options.discipline.id > 0 &&
        this.options.municipality.id > 0
      ) {
        await this.getRegistrationDate();

        let showErrorFlag = true;
        if (this.params.studentReferralId != null) {
          showErrorFlag = false;
        }

        const { data: response } = await this.$ApiGet(
          '/api/appointment/searchdates',
          {
            disciplineId: this.options.discipline.id,
            municipalityId: this.options.municipality.id,
            date: startDate,
            registrationDate: this.registrationDate,
            showErrorFlag: showErrorFlag,
          }
        );

        this.weekDays = response;
        this.$emit('getWeekDays', {
          weekDays: this.weekDays,
          evaluationTypeId: this.serviceTypeId,
        });
        this.$emit('set-show-create-new-referral-option', true);
        await this.$refs.validatorForm.reset();
      } else {
        await this.$refs.validatorForm.validate();
        this.ShowToast(
          'Atención.',
          'Debe seleccionar el campo Disciplina y el campo Pueblo para poder realizar la búsqueda.',
          'error'
        );
      }
    },
    changeWeek(data) {
      const date = data.startDate || data;
      this.getAvailableDates(date);
    },
    async loadDiscipline() {
      this.serviceTypeId = this.serviceType?.id
        ? this.serviceType?.id
        : this.serviceTypeId;

      const { data } = await this.$ApiGet(
        `api/appointment/getvalidappointmentdisciplinesforddl/${this.serviceTypeId}`
      );

      this.disciplineList = data;

      if (this.defaultDiscipline) {
        this.options.discipline = this.disciplineList.find(
          (dis) => dis.id == this.defaultDiscipline
        );
        this.disabledDiscipline = this.options.discipline != undefined;
        await this.loadMunicipality();
      }
    },
    async onDisiplineChange() {
      await this.loadMunicipality();
      if (!this.municipality.length) {
        this.$emit('set-show-create-new-referral-option', true);
      }
    },
    async loadMunicipality() {
      let self = this;
      if (
        self.options.discipline == null ||
        this.student.studentId === undefined
      )
        return;
      let disciplineId = self.options.discipline.id;
      let age = null;

      if (this.student.age != null) {
        age = this.student.age;
      } else if (this.$store.getters['$_student/getMipeStudent'] != null) {
        age = this.$store.getters['$_student/getMipeStudent'].age;
      }
      await appointmentServices
        .hasActiveAppointmentByDiscipline({
          DiciplineType: this.options.discipline.id,
          studentSieId: this.student.studentId,
          appointmentId: this.cancelAppointmentId,
        })
        .then(async (res) => {
          this.hasActiveCoordinatedDiscipline = res.data.hasActive;
          this.activeAppointmentErrorMessage = res.data.message;
          this.municipality = [];

          if (!this.hasActiveCoordinatedDiscipline) {
            await self
              .$ApiGet('/api/appointment/getmunicipalitiesbydicipline', {
                DiciplineType: disciplineId,
                studentAge: parseInt(age ?? 0),
              })
              .then((res) => {
                this.showErrorDiscipline = false;

                if (res.data.length > 0) {
                  self.hasValue = true;
                } else {
                  self.hasValue = false;
                  self.$refs.validatorForm.validate();
                }
                self.municipality = res.data;
              });
          } else {
            this.showErrorDiscipline = true;
          }
        });
    },
    Loadbreach() {
      if (this.student.regStudentId == null) return;

      if (this.params.studentReferralId != null) return;

      if (this.serviceTypeId == 1) {
        this.$ApiGet('/api/appointment/getbreach', {
          RegStudentId: this.student.regStudentId,
        }).then((res) => {
          let item = res.data;
          if (item.breachOver) {
            this.breach = 'Días Incumplimiento: ' + item.breach;
          } else {
            this.breach = 'Días Antes de Incumplimiento: ' + item.breach;
          }
        });
      }
    },
  },
  async mounted() {
    await this.loadResources();
    await this.Loadbreach();
    this.serviceType = this.serviceTypeList.find(
      (x) => x.id === this.serviceTypeId
    );
    await this.loadDiscipline();

    const section = 1;
    this.$emit('change-section', section);
  },
  watch: {
    async student() {
      await this.Loadbreach();

      if (this.defaultDiscipline) {
        await this.loadMunicipality();
      }
    },
    async serviceType(newValue) {
      this.disciplineList = [];
      this.options.discipline = null;

      if (newValue?.id > 0) await this.loadDiscipline();
    },
    'options.discipline': async function() {
      await this.$refs.validatorForm.reset();
      this.showErrorDiscipline = false;
      this.options.municipality = null;
      this.municipality = [];
      this.errorDisciplineMessage = this.resources['R90025'];
    },
  },
};
</script>
